import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { packageServices } from "../../services/packageServices";
import Tooltip from '@mui/material/Tooltip';
import { isEmptyDash } from "../../constant";
import { DatePicker, Space } from 'antd';

function Filter(props) {
  const accordionCount = 16;
  const [openAccordions, setOpenAccordions] = useState(
    Array.from({ length: accordionCount }, () => false)
  );
  const [filterlist, setFilterlist] = React.useState();
  const [filteredFilterlist, setFilteredFilterlist] = useState(filterlist);
  const [searchText, setSearchText] = useState("");
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
  }, [props.isFilterModalOpen]);

  useEffect(() => {
    setFilteredFilterlist(filterlist);
  }, [filterlist]);
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    const updatedAccordions = [...openAccordions];
    updatedAccordions[anchor] = open;
    setOpenAccordions(updatedAccordions);
  };

  const handleClickAccordion = (index) => {
    if (index !== 0) {
      // Do not toggle for "Vendor ID"
      const updatedAccordions = [...openAccordions];
      updatedAccordions[index] = !updatedAccordions[index];
      setOpenAccordions(updatedAccordions);
    }
  };
  useEffect(() => {
    packageServices
      .getFilterDetail(props?.uniqueName)
      .then((res) => {
        if (res.data.success === true) {
          setFilterlist(res?.data?.data);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }, []);

  const [filterFieldsDetails, setfilterFieldsDetails] = useState({});

  // const handleInputChange = (e, ele, index) => {
  //   const { name, value } = e.target;
  //   setfilterFieldsDetails((prevDetails) => ({
  //     ...prevDetails, [name]: value
  //   }
  //     // [name]: {
  //     //   // ...prevDetails[index],
  //     //   // [name]: value,
  //     //   value,
  //     // },
  //     // }
  //   ));
  // };


  const handleInputChange = (e, ele, index) => {
    const { name, value, type, checked } = e.target;
    setfilterFieldsDetails((prevDetails) => {
      if (type === "checkbox") {
        let newValueArray = prevDetails[name] ? prevDetails[name].split(',') : [];
        if (checked) {
          if (!newValueArray.includes(value)) {
            newValueArray.push(value);
          }
        } else {
          newValueArray = newValueArray.filter((item) => item !== value);
        }
        const newValue = newValueArray.join(',');
        return {
          ...prevDetails,
          [name]: newValue,
        };
      } else {
        return {
          ...prevDetails,
          [name]: value,
        };
      }
    });
  };

  const handleRangeChange = (dates, dateStrings, ele, index) => {
    if (dates) {
      // Simulate an event for the "From" date
      handleInputChange(
        { target: { name: `${ele.field}_from_date`, value: dateStrings[0] } },
        ele,
        index
      );
      // Simulate an event for the "To" date
      handleInputChange(
        { target: { name: `${ele.field}_to_date`, value: dateStrings[1] } },
        ele,
        index
      );
    }
  };
  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split('-');
    return new Date(year, month - 1, day);
  };
  const formatDateToDisplay = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const handleSubmit = () => {
    const formattedFilterFields = {};
    // for (const key in filterFieldsDetails) {
    //   if (filterlist.find(ele => ele.field === key)?.type === 'date' && filterFieldsDetails[key]) {
    //     formattedFilterFields[key] = formatDateToDisplay(filterFieldsDetails[key]);
    //   } else {
    //     formattedFilterFields[key] = filterFieldsDetails[key];
    //   }
    // }

    for (const key in filterFieldsDetails) {
      const value = filterFieldsDetails[key];
      if (!isEmptyDash(value)) {
        if (key.endsWith('_from_date')) {
          const fieldBaseName = key.replace('_from_date', '');
          const fromDate = filterFieldsDetails[key];
          const toDate = filterFieldsDetails[`${fieldBaseName}_to_date`];
          if (fromDate || toDate) {
            formattedFilterFields[fieldBaseName] = `${fromDate || ''},${toDate || ''}`;
          }
        } else if (!key.endsWith('_to_date')) {
          formattedFilterFields[key] = filterFieldsDetails[key];
        }
      }
    }
    props.formSubmitFunction(formattedFilterFields);
    setOpenAccordions(prevState => {
      const updatedState = [...prevState];
      updatedState[0] = false;
      return updatedState;
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      const formattedFilterFields = {};
      for (const key in filterFieldsDetails) {
        if (filterlist.find(ele => ele.field === key)?.type === 'date' && filterFieldsDetails[key]) {
          formattedFilterFields[key] = formatDateToDisplay(filterFieldsDetails[key]);
        } else {
          formattedFilterFields[key] = filterFieldsDetails[key];
        }
      }
      props.formSubmitFunction(formattedFilterFields);
      setOpenAccordions(prevState => {
        const updatedState = [...prevState];
        updatedState[0] = false;
        return updatedState;
      });
    }
  };

  const handleCloseDrawer = (index) => () => {
    setOpenAccordions(prevState => {
      const updatedState = [...prevState];
      updatedState[index] = false;
      return updatedState;
    });
  };

  const handleClearField = (field) => {
    const dateFields = [`${field}_from_date`, `${field}_to_date`];

    // Clear specific date fields if they exist
    setfilterFieldsDetails((prevDetails) => {
      const updatedDetails = { ...prevDetails };
      dateFields.forEach(dateField => {
        if (dateField in updatedDetails) {
          updatedDetails[dateField] = '';
        }
      });
      updatedDetails[field] = '';
      return updatedDetails;
    });
  };
  const isChecked = (field, value) => {
    const values = filterFieldsDetails[field]?.split(',') || [];
    return values.includes(value);
  };

  const handleResetForm = () => {
    const resetFields = {};
    for (const key in filterFieldsDetails) {
      if (Array.isArray(filterFieldsDetails[key])) {
        resetFields[key] = '';
      } else {
        resetFields[key] = '';
      }
    }
    setSearchText('');
    setFilteredFilterlist(filterlist);
    setfilterFieldsDetails(resetFields);
    props.resetFilter();
  };


  const handleSearchChange = (e) => {
    const newSearchText = e.target.value;
    setSearchText(newSearchText);

    const newFilteredFilterlist = filterlist ? filterlist.filter(item =>
      item.label.toLowerCase().includes(newSearchText.toLowerCase())
    ) : [];

    setFilteredFilterlist(newFilteredFilterlist);
  };
  // const filteredFilterlist = [];
  // const filteredFilterlist = filterlist ? filterlist.filter(item =>
  //   item.label.toLowerCase().includes(searchText.toLowerCase())
  // ) : [];

  const list = (anchor) => (
    <Box
      className="lets_block_listing_filter_btn"
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 350,
        zIndex: 1300,
      }}
      role="presentation"
    >
      <div className="lets_filter_vendorlist_react_one1">
        <p className="react_down_one_lsit">Filter</p>
        <p className="react_down_reset_lsits1" onClick={handleResetForm} style={{ cursor: 'pointer' }}>Reset</p>

      </div>
      <div className="search_react_main_clear_formone">
        <div className="">
          <div id="custom-search-input">
            <div className="input-group col-md-12">
              <input
                type="text"
                className="form-control input-lg "
                placeholder="Search here"
                // fdprocessedid="7yu8sn"
                value={searchText}
                onChange={handleSearchChange}
              />
              <span className="input-group-btn">
                <button
                  disabled
                  className="btn btn-info btn-lg"
                  type="button"
                // onClick={onFilterSubmit}
                >
                  <span className="glyphicon glyphicon-search">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-search"
                      viewBox="0 0 16 16"
                    >
                      <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                    </svg>
                  </span>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="lets_block_listing_filter_overflow">
        <List>

          {filteredFilterlist?.map((ele, index) => (
            <React.Fragment key={ele}>
              <ListItemButton className="vendor_list_text_block" onClick={() => handleClickAccordion(index)} >
                <ListItemText primary={ele.label} />
                {openAccordions[index] ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>

              <Collapse in={openAccordions[index]} timeout="auto">
                <List component="div" sx={{ pl: 4 }} style={{ paddingLeft: "0px" }}>
                  <ListItem style={{ paddingTop: "0px" }
                  } >
                    <div class="text" style={{ width: "100%" }}>
                      {ele.type === "text" && ele?.isVisible === true && (
                        <div className="fiter_contol_br_row_inputbtn">
                          <>
                            <input
                              className="form-control "
                              type="text"
                              aria-label="Disabled input example"
                              fdprocessedid="s5btrv"
                              name={ele.field}
                              value={filterFieldsDetails[ele.field]}
                              onChange={(e) => handleInputChange(e, ele, index)}
                              onKeyDown={handleKeyDown}
                              style={{ width: "100%" }}
                            />
                            <Tooltip title="Clear" placement="top-start"> <button type="button" className="btn-close" onClick={() => handleClearField(ele.field)}
                            ></button></Tooltip>

                          </>
                        </div>
                      )}

                      {ele.type === "select" && ele?.isVisible === true && (
                        <>

                          <div className="filter_order_date_control_row">
                            <select
                              style={{ margin: '-2rem !important' }}
                              className="form-select form_ha_fiterselectinput"
                              aria-label="Default select example"
                              name={ele?.field}
                              value={filterFieldsDetails[ele.field] || ''}
                              onChange={(e) => handleInputChange(e, ele, index)}

                            >
                              <option value={"null"}>
                                Please Select
                              </option>
                              {ele?.choices.map((optionEle, i) => (
                                <>
                                  <option key={i} value={optionEle.value}>
                                    {optionEle.label}
                                  </option>
                                </>
                              ))}
                            </select>
                            <Tooltip title="Clear" placement="top-start"> <button type="button" className="btn-close" onClick={() => handleClearField(ele.field)}
                            ></button></Tooltip>
                          </div>
                        </>
                      )}
                      {ele.type === "date" && ele?.isVisible === true && (
                        <>
                          <div className="filter_order_date_control_row">

                            {/* <Space direction="vertical" size={12}>
                              <DatePicker.RangePicker
                                getPopupContainer={(trigger) => trigger.parentNode}
                                placement="bottomLeft"
                                onChange={handleRangeChange}
                                // disabledDate={disabledDate}
                                format="DD-MM-YYYY"
                                value={[
                                  filterFieldsDetails[`${ele.field}_from_date`]
                                    ? parseDate(filterFieldsDetails[`${ele.field}_from_date`], "DD-MM-YYYY")
                                    : null,
                                  filterFieldsDetails[`${ele.field}_to_date`]
                                    ? parseDate(filterFieldsDetails[`${ele.field}_to_date`], "DD-MM-YYYY")
                                    : null,
                                ]}
                              />
                            </Space> */}

                            <div className="row">
                              <div className="col-sm-6">
                                <span>From:</span>
                                <input
                                  type="date"
                                  id="date"
                                  class="form-control"
                                  placeholder="03-03-2024"
                                  name={`${ele.field}_from_date`}
                                  value={filterFieldsDetails[`${ele.field}_from_date`] || ""}
                                  onChange={(e) => handleInputChange(e, ele, index)}
                                  onKeyDown={handleKeyDown}
                                />
                              </div>
                              <div className="col-sm-6">
                                <span>To:</span>
                                <input
                                  type="date"
                                  id="date"
                                  class="form-control"
                                  placeholder="03-03-2024"
                                  name={`${ele.field}_to_date`}
                                  value={filterFieldsDetails[`${ele.field}_to_date`] || ""}
                                  onChange={(e) => handleInputChange(e, ele, index)}
                                  onKeyDown={handleKeyDown}
                                />
                              </div>
                            </div>

                            <Tooltip title="Clear" placement="top-start"><button type="button" className="btn-close" onClick={() => handleClearField(ele.field)}
                            ></button></Tooltip>
                          </div>
                        </>
                      )}
                      {ele.type === "checkbox" && ele?.isVisible === true && (
                        <>
                          <Tooltip title="Clear" placement="top-start"> <button type="button" className="btn-close" onClick={() => handleClearField(ele.field)}
                          ></button></Tooltip>
                          {ele?.choices.map((optionEle, i) => (
                            <>
                              <div class="statuss" style={{ display: "flex", alignItems: "baseline", gap: "0.5rem" }}>
                                <input type="checkbox" className="" name={ele?.field} key={i} value={optionEle.value} onChange={(e) => handleInputChange(e, ele, index)} checked={isChecked(ele.field, optionEle.value)} /> <span style={{ textAlign: "left" }}>{optionEle.label}</span>
                              </div>
                            </>
                          ))}
                        </>
                      )}
                    </div>
                  </ListItem>
                </List>
              </Collapse>
            </React.Fragment>
          ))
          }
        </List >
      </div>
      <Divider />
      <div>
        <button
          type="button"
          class="btn btn-success save_next_btn_submit"
          fdprocessedid="ao4xc"
          onClick={handleSubmit}
        >
          Apply
        </button>
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          fdprocessedid="0y9izm"
          onClick={handleCloseDrawer(0)}
        >
          Close
        </button>
      </div>
    </Box >
  );

  return (
    <div>
      {["right"].map((anchor, index) => (
        <React.Fragment key={anchor} >
          <Button
            className="filter_detail_index_text" style={{ padding: "0px" }}
            onClick={toggleDrawer(index, true)}
          // style={{ zIndex: 1400 }}
          >
            {/* <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-funnel"
                viewBox="0 0 16 16"
              >
                <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z"></path>
              </svg>
            </span> */}
            Filter
          </Button>
          <SwipeableDrawer
            anchor={anchor}
            open={openAccordions[index]}
            onClose={toggleDrawer(index, false)}
            onOpen={toggleDrawer(index, true)}
            style={{ zIndex: 99999 }}
          >
            {list(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))
      }
    </div >
  );
}

export default Filter;
